import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closePopup } from "../../Modal/action";
import "./style.scss";
import Ecart from "../ECartModal/Ecart";
import { useState } from "react";
import CartDetails from "./CartDetails";
import AllSchemes from "./AllSchemes";
import EKyc from "./Common/eKYC";
import Folio from "./Common/Folio";
import ReplaceItems from "../ReplaceItems";

const ECartModal = (props) => {
  const {
    closePopup,
    returnValue,
    joruneyPage,
    getFundDetails,
    fundName,
    fundCode,
    objectt,
    verifyOtpData,
    isDirect,
    isRegular,
    invest, 
    // popupData, 
    // handlepopupshow, 
    // handlepopupClose,
    isJanNivesh,
  } = props;
  const [cartJourneyPage, setCartJourneyPage] = useState(0);
  const [fundData, setFundData] = useState({});

  const onAddToCartClick = (fundDetails) => {
    if (fundDetails) {
      setFundData({
        ...fundDetails,
        fundCode: fundDetails.fundCode,
        fundName: fundDetails.fundName,
        directFund:
          fundDetails.directScheme && fundDetails.directScheme.length > 0,
      });
    }
    setCartJourneyPage(0);
  };

  useEffect(() => {
    if (fundName && fundCode) {
      setFundData({
        fundCode: fundCode,
        fundName: fundName,
        isDirect: isDirect,
        isRegular: isRegular,
      });
    }
  }, [fundCode]);

  useEffect(() => {
    if (joruneyPage) {
      setCartJourneyPage(joruneyPage);
    }
  }, [joruneyPage]);

  return (
    <div>
      <div className="popupOuter">
        <div className="popupSec">
          <div>
            <div>
              {cartJourneyPage === 0 && (
                <CartDetails
                  setCartJourneyPage={setCartJourneyPage}
                  fundData={fundData}
                  InvestNow={invest} 
                  // popupData={popupData} 
                  // handlepopupshow={handlepopupshow} 
                  // handlepopupClose={handlepopupClose}
                  isJanNivesh={isJanNivesh ? isJanNivesh : false}
                />
              )}
              {(cartJourneyPage === 1 ||
                cartJourneyPage === 3 ||
                cartJourneyPage === 4) && (
                <Ecart
                  setCartJourneyPage={setCartJourneyPage}
                  onAddToCartClick={(fundDetails) =>
                    onAddToCartClick(fundDetails)
                  }
                />
              )}
              {cartJourneyPage === 2 && (
                <AllSchemes
                  setCartJourneyPage={setCartJourneyPage}
                  onAddToCartClick={(fundDetails) =>
                    onAddToCartClick(fundDetails)
                  }
                />
              )}
              {cartJourneyPage === 5 && (
                <EKyc
                  setCartJourneyPage={setCartJourneyPage}
                  objectt={objectt}
                />
              )}
              {cartJourneyPage === 6 && (
                <Folio
                  setCartJourneyPage={setCartJourneyPage}
                  verifyOtpData={verifyOtpData}
                />
              )}
              {cartJourneyPage === 7 && (
                <ReplaceItems setCartJourneyPage={setCartJourneyPage} />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="popup_overlay black_overlay" />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  closePopup: bindActionCreators(closePopup, dispatch),
});

export default connect("", mapDispatchToProps)(ECartModal);
